import { Card } from '../../../Card'
import { Confirmation } from '../../Confirmation'

const Success = () => (
  <Card>
    <Confirmation isReschedule />
  </Card>
)

export { Success }
